import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const STORAGE_KEY = 'obsidian.cookie-consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    }, 700);
    return () => clearTimeout(t);
  }, []);

  const persist = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, ts: new Date().toISOString() }));
    } catch { /* private mode */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-[60] bg-black text-white border-t border-white/10 shadow-2xl animate-in slide-in-from-bottom-4"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm text-white/80 flex-1 leading-relaxed">
          We use cookies to make this site work properly, remember your booking details and improve performance.{' '}
          <Link to="/privacy" className="underline hover:text-white">Read our privacy policy</Link>.
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <Button
            variant="outline"
            onClick={() => persist('rejected')}
            className="border-white/30 bg-transparent text-white hover:bg-white hover:text-black h-9 px-4"
            data-testid="cookie-reject"
          >
            Reject
          </Button>
          <Button
            onClick={() => persist('accepted')}
            className="bg-white text-black hover:bg-gray-200 h-9 px-5 font-semibold"
            data-testid="cookie-accept"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
